import React, { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import "../../Styles/styles-StatusTracker.css";
import { 
    Avatar,
} from "antd";


export const ACWRDot = ({ idx, value, circleColor, metricName }) => {
    
    return (
        <>
            <Avatar 
                className="tracker-ACWR-dots"
                src={undefined}
                style={{ backgroundColor: circleColor}}
                size={8}
                shape="circle"
            />  
        </>
    
    );
};
